<template>
  <a>正在授权</a>
</template>

<script>
export default {
  name: 'Authorization',
  data () {
    return {}
  },
  mounted () {
    this.getCodeApi(this.$route.query.pageName)
  },
  methods: {
    getCodeApi (page) {
      let state = page
      // 获取code
      // let urlNow = encodeURIComponent(location.href)
      let urlNow = encodeURIComponent('http://www.xjwxfd.cn/')
      let scope = 'snsapi_base' // snsapi_base snsapi_userinfo   //静默授权 用户无感知
      let appid = 'wx8c914d445074bbdc'
      // https://open.weixin.qq.com/connect/qrconnect?appid=APPID&redirect_uri=REDIRECT_URI&response_type=code&scope=SCOPE&state=STATE#wechat_redirect
      // https://open.weixin.qq.com/cgi-bin/showdocument?action=dir_list&t=resource/res_list&verify=1&id=open1419316505&token=&lang=zh_CN
      let url = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appid}&redirect_uri=${urlNow}&response_type=code&scope=${scope}&state=${state}#wechat_redirect`
      window.location.href = url
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/Authorization.vue